// import router from '@/app/router';
import store from '@/app/store';
// import { setLoan } from '@/processes/Loan/setLoan';

export default function centrifugeSubscribe({ centrifuge, uidChannel }) {
	console.log('uidChannel:', uidChannel);
	if (uidChannel) {
		console.log('centrifugeSUB', uidChannel);
		// eslint-disable-next-line consistent-return
		centrifuge.subscribe(uidChannel, async (message) => {
			console.log('centrifugeSubscribe: ', message);

			if (Object.hasOwn(message.data, 'status_loan_app')) {
				// is close - заявка закрыта или оформлен договор
				// is editable - можем редактировать заявку
				if (message.data.status_loan_app?.is_editable === true || message.data.status_loan_loann?.is_close === true) {
					window.location.href = '/';
					return;
				}
				store.commit('SET_CENTRIFUGE_STATUS', {
					...store.state.centrifugeStatus,
					loanStatus: message.data.status_loan_app?.slug,
				});
			}

			if (Object.hasOwn(message.data, 'payout')) {
				store.commit('SET_CENTRIFUGE_STATUS', {
					...store.state.centrifugeStatus,
					payoutStatus: {
						status: message.data.payout.status,
						errorMessage: message.data.payout.error_message,
					},
				});
			}

			if (message.data.verification_document) {
				console.log('SET_VERIFICATION_DOC (centrifuge):');
				store.commit('passportDownload/SET_VERIFICATION_DOC', message.data.verification_document);
				console.log('CENTRIFUGE STATUS ', message.data.verification_document.status);
			}
			if (message.data.verification_process) {
				console.log('SET_VERIFICATION_DATA (centrifuge):');
				store.commit('passportDownload/SET_VERIFICATION_DATA', message.data.verification_process);
			}
		});
	}
}
